import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resturlConstants } from '../../../rest-url/resturlconstants';
import { environment } from '../../../environments/environment';
import { HomeService } from '../../home/home.service';

@Injectable()
export class LockersService {

  constructor(private http: HttpClient, private homeService: HomeService) { }

  lockersData(): Observable<any> {
    return this.http.post<any>(resturlConstants.LockersUrl, {
      'userId': localStorage.getItem('userId'),
      'clientShortCode': environment.clientShortCode
    },
      {
        headers: new HttpHeaders()
          .set('Content-type', 'application/JSON')
          .set('Authorization', this.homeService.getAuthHeader())
      });
  }
}
